import React from 'react';
import { useHistory } from 'react-router-dom';
import { APP_FEATURE_CONFIG } from 'src/config/constant';

const AmcAccessGuard = ({ children }) => {
  const history = useHistory();
  const selectedProfileId = JSON.parse(sessionStorage.getItem('selectedProfileId'));
  const availablePermission = selectedProfileId?.permissions || []
  const isAmazon = window.location.href.indexOf('/amazon') > -1

  if (
    APP_FEATURE_CONFIG?.AMAZON_SUB_PERMISSIONS_CHECK === true &&
    isAmazon &&
    Array.isArray(availablePermission) &&
    availablePermission.length > 0 &&
    !availablePermission.includes('AMC')
  ) {
    history.push('/amazon/restricted', { deniedPage: 'AMC' });
    return null;
  }

  return  <React.Fragment>{children}</React.Fragment>; 
};

export default AmcAccessGuard;
